export class LevenshteinConfiguration {

  public id: number;

  public diff: number = 0;
}
